import axios from 'axios';
import { setAlert } from './alert';
import {
    GET_SERVICE_TYPES, ADD_SERVICE_TYPE, SERVICE_TYPE_ERROR
} from './types';

import { base_url } from './constants';

axios.defaults.baseURL = base_url;
//GET Service Types
export const getServiceTypes = () => async dispatch => {
    try {
        const res = await axios.get('/api/service_types/');

        dispatch({ type: GET_SERVICE_TYPES, payload: res.data })
    } catch (err) {
        dispatch({
            type: SERVICE_TYPE_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });
    }
}


export const createServiceType = formData => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try {
        const res = await axios.post('/api/service_types/create', formData, config);
        dispatch({
            type: ADD_SERVICE_TYPE,
            payload: res.data
        });

        dispatch(setAlert('Service Created', 'success'));


    } catch (err) {
        const errors = err.response.data.errors;
        console.log(errors);
        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: SERVICE_TYPE_ERROR,
        });
    }
}